import _extends from "@swc/helpers/src/_extends.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { useSession } from "next-auth/react";
export function DashboardHeader(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, logo = _param.logo, _links = _param.links, links = _links === void 0 ? [] : _links, menu = _param.menu, rest = _object_without_properties(_param, [
        "className",
        "logo",
        "links",
        "menu"
    ]);
    var ref = useSession(), session = ref.data;
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: clsx("z-10 relative w-full py-4 flex mx-auto space-x-4", true ? "items-end" : "items-center", className)
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center gap-4",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-col justify-center space-y-4",
                    children: logo
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex-auto"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center ",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex items-center md:space-x-8",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "hidden space-x-8 items-center md:flex",
                            children: Array.isArray(links) ? links.map(function(x, i) {
                                return /*#__PURE__*/ _jsx("span", {
                                    children: x
                                }, i);
                            }) : links
                        }),
                        menu
                    ]
                })
            })
        ]
    }));
}
import ColorHash from "color-hash";
import { colord, extend } from "colord";
import harmoniesPlugin from "colord/plugins/harmonies";
import mixPlugin from "colord/plugins/mix";
extend([
    mixPlugin,
    harmoniesPlugin
]);
var colorHash = new ColorHash({
    lightness: 0.6
});
export function AvatarButton(param) {
    var className = param.className, tmp = param.as, As = tmp === void 0 ? "button" : tmp, name = param.name;
    var background = function() {
        if (!name) {
            return "#aaa";
        }
        var color = colorHash.hex(name);
        var ref = _sliced_to_array(colord(color).harmonies("analogous"), 2), first = ref[0], second = ref[1];
        return "linear-gradient(to right, ".concat(first.desaturate(0.2).toHex(), ", ").concat(second.desaturate(0.4).toHex(), ")");
    }();
    return /*#__PURE__*/ _jsx(As, {
        role: "button",
        "aria-label": "avatar button",
        style: {
            background: background
        },
        className: "rounded-full w-12 h-12 active:opacity-40" + className,
        children: /*#__PURE__*/ _jsx(ProfileSvg, {
            className: "opacity-80"
        })
    });
}
function ProfileSvg(_param) {
    var rest = _extends({}, _param);
    return /*#__PURE__*/ _jsxs("svg", _object_spread_props(_object_spread({
        viewBox: "0 0 128 128",
        className: "",
        role: "img",
        "aria-label": " avatar"
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                fill: "#fff",
                d: "M103,102.1388 C93.094,111.92 79.3504,118 64.1638,118 C48.8056,118 34.9294,111.768 25,101.7892 L25,95.2 C25,86.8096 31.981,80 40.6,80 L87.4,80 C96.019,80 103,86.8096 103,95.2 L103,102.1388 Z"
            }),
            /*#__PURE__*/ _jsx("path", {
                fill: "#fff",
                d: "M63.9961647,24 C51.2938136,24 41,34.2938136 41,46.9961647 C41,59.7061864 51.2938136,70 63.9961647,70 C76.6985159,70 87,59.7061864 87,46.9961647 C87,34.2938136 76.6985159,24 63.9961647,24"
            })
        ]
    }));
}
